<template>
  <div class="admin-sidebar d-flex flex-column p-4 shadow-sm">
    <h5 class="sidebar-title mb-4">Management</h5>
    <router-link to="/admin/products" class="sidebar-link mb-2">
      <i class="bi bi-box-seam me-2"></i> Products
    </router-link>
    <router-link to="/admin/contacts" class="sidebar-link mb-2">
      <i class="bi bi-envelope-paper me-2"></i> Contacts
    </router-link>
  </div>
</template>

<script>
export default {
  name: "AdminSidebar",
};
</script>

<style scoped>
.admin-sidebar {
  min-height: 100vh;
  width: 230px;
  background: linear-gradient(180deg, #c89d43, #b0842d);
  color: #fff;
  font-family: "Poppins", sans-serif;
}

.sidebar-title {
  font-weight: 600;
  font-size: 1.1rem;
  letter-spacing: 0.3px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 8px;
}

.sidebar-link {
  color: #fff;
  text-decoration: none;
  padding: 0.6rem 0.8rem;
  border-radius: 6px;
  display: flex;
  align-items: center;
  transition: all 0.25s ease;
}

.sidebar-link:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateX(4px);
}

.router-link-active {
  background: rgba(255, 255, 255, 0.25);
  font-weight: 600;
}
</style>
